import useSWR from 'swr';
import { scoreReportService } from 'services';
import { useAuth } from 'hooks';
import { Heading, Loading } from 'components';
import { formatTimestamp } from 'helpers';
import { ScoreDisplay, ServiceChart } from './components';
import * as S from './styles';

interface Props {
  showScore: boolean;
}

export function ScoreResume({ showScore }: Props) {
  const { selectedStore } = useAuth();
  const store = selectedStore.name;

  const { data, isLoading } = useSWR(
    `score-resume-${store}`,
    () => scoreReportService.getResume({ store }),
    { revalidateOnFocus: false }
  );

  if (isLoading) {
    return (
      <S.Wrapper>
        <Loading />
      </S.Wrapper>
    );
  }

  if (!data) {
    return (
      <S.Wrapper>
        <Heading as="h3">
          Erro ao carregar o resumo do nível de atendimento
        </Heading>
      </S.Wrapper>
    );
  }

  const { priority, daysPerformance } = data;

  const lastDaysPerformance = daysPerformance.length - 1;
  const startDate = formatTimestamp(daysPerformance[0].date);
  const endDate = formatTimestamp(daysPerformance[lastDaysPerformance].date);

  return (
    <S.Wrapper>
      {showScore && (
        <div className="small-container">
          <ScoreDisplay
            score={priority}
            startDate={startDate.formattedDate}
            endDate={endDate.formattedDate}
          />
        </div>
      )}

      <div className="large-container">
        <ServiceChart daysPerformance={daysPerformance} />
      </div>
    </S.Wrapper>
  );
}
